import { render, staticRenderFns } from "./help-panel.vue?vue&type=template&id=28c296b6&"
import script from "./help-panel.vue?vue&type=script&lang=js&"
export * from "./help-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports